import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { MultiMeasurement } from "../../database"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import SyncableModel from "../../database/SyncableModel";
import JalaAnalytic from "../../utils/jala-analytic"

const PlanktonMultiMeasurementProps = {
  ...BaseModelStoreProps
}

/**
 * Model description here for TypeScript hints.
 */
export const PlanktonMultiMeasurementModel = types
  .model("PlanktonMultiMeasurement")
  .props(PlanktonMultiMeasurementProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof PlanktonMultiMeasurementProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async store(data) {
      if (self.rootStore.appStore?.isOffline)
        return this.storeOffline(data)
      return self.storeModel(MultiMeasurement, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Plankton added', data);
          return success;
        });
    },
    async storeOffline(data) {
      return self.storeModelOffline(MultiMeasurement, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Plankton added', data);
          return success;
        });
    },
    async update(model: SyncableModel, data) {
      if (self.rootStore.appStore?.isOffline)
        return this.updateOffline(model, data)
      return self.updateModel(MultiMeasurement, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Plankton edited', data);
          return success;
        });
    },
    async updateOffline(model: SyncableModel, data) {
      return self.updateModelOffline(MultiMeasurement, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Plankton edited', data);
          return success;
        });
    },
    async delete(model: SyncableModel) {
      if (self.rootStore.appStore?.isOffline)
        return this.deleteOffline(model)
      return self.deleteModel(MultiMeasurement, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Plankton deleted', model.toArray());
          return success;
        });
    },
    async deleteOffline(model: SyncableModel) {
      return self.deleteModelOffline(MultiMeasurement, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Plankton deleted', model.toArray());
          return success;
        });
    }
  }))

type PlanktonMultiMeasurementType = Instance<typeof PlanktonMultiMeasurementModel>
export interface PlanktonMultiMeasurementStore extends PlanktonMultiMeasurementType {}
type PlanktonMultiMeasurementSnapshotType = SnapshotOut<typeof PlanktonMultiMeasurementModel>
export interface PlanktonMultiMeasurementSnapshot extends PlanktonMultiMeasurementSnapshotType {}
export const createPlanktonMultiMeasurementDefaultModel = () => types.optional(PlanktonMultiMeasurementModel, {})
